import Typography from '@mui/material/Typography'
import CustomLink from './Reusables/CustomLink'

function PageTitle({ children, href }) {
  return (
    <Typography
      component={'h2'}
      variant='h4'
      pb={1}
      borderBottom={'2px solid var(--mui-palette-border-items)'}
      my={1}
      display={'flex'}
    >
      {href ? (
        <CustomLink href={href ?? '#'} underline='hover'>
          {children}
        </CustomLink>
      ) : (
        children
      )}
    </Typography>
  )
}

export default PageTitle
